import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { ConfigProvider, App } from 'antd'
import Loading from 'components/shared-components/Loading'
import { lightTheme, darkTheme } from 'configs/ThemeConfig'
import { resources } from 'lang'
import useBodyClass from 'utils/hooks/useBodyClass'
import routes from 'routes'
import { RouterProvider } from 'react-router-dom'
import styled from '@emotion/styled'
import FeedbackProvider from 'components/util-components/FeedbackProvider'

const AntdApp = styled(App)`
  height: 100%;
`

const Layouts = () => {
  const locale = useSelector((state) => state.theme.locale)
  const direction = useSelector((state) => state.theme.direction)
  const currentTheme = useSelector((state) => state.theme.currentTheme)
  const currentAppLocale = resources[locale]

  useBodyClass(`dir-${direction}`)

  const themeConfig =
    currentTheme === 'light' ? { ...lightTheme } : { ...darkTheme }

  document.documentElement.style.colorScheme = currentTheme

  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      locale={currentAppLocale.antd}
    >
      <AntdApp>
        <FeedbackProvider>
          <RouterProvider
            router={routes}
            fallback={<Loading cover='content' />}
          />
        </FeedbackProvider>
      </AntdApp>
    </ConfigProvider>
  )
}

export default memo(Layouts)
